module.exports = __webpack_public_path__ + "static/sagebooties-8fe7a4c50c847725cdf923f4e527e148.jpeg";